import { EMPTY_QUILL_HTML } from './constants';

const ALLOWED_TAGS = new Set(['P', 'BR', 'STRONG', 'B', 'EM', 'I', 'U', 'OL', 'UL', 'LI', 'SPAN']);

function getFallbackPlainText(html: string): string {
  return html
    .replace(/<style[\s\S]*?<\/style>/gi, '')
    .replace(/<script[\s\S]*?<\/script>/gi, '')
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ')
    .trim();
}

export function getQuillPlainText(html?: string | null): string {
  if (!html || html === EMPTY_QUILL_HTML) return '';

  if (!globalThis.document) {
    return getFallbackPlainText(html);
  }

  const container = document.createElement('div');
  container.innerHTML = html;

  return (container.textContent ?? '').replace(/\u00a0/g, ' ').trim();
}

export function sanitizeQuillHtml(html?: string | null): string {
  if (!html || html === EMPTY_QUILL_HTML) return '';

  if (!globalThis.document) {
    return html;
  }

  const template = document.createElement('template');
  template.innerHTML = html;

  template.content.querySelectorAll('script, style').forEach((node) => node.remove());
  template.content.querySelectorAll('*').forEach((element) => {
    if (!ALLOWED_TAGS.has(element.tagName)) {
      element.replaceWith(...Array.from(element.childNodes));
      return;
    }

    Array.from(element.attributes).forEach((attribute) => {
      if (element instanceof HTMLElement && element.tagName === 'SPAN' && attribute.name === 'style') {
        const color = element.style.color;
        element.removeAttribute('style');
        if (color) {
          element.style.color = color;
        }
        return;
      }

      element.removeAttribute(attribute.name);
    });
  });

  return template.innerHTML;
}
